import $ from './jquery.js';
import './touchswipe.js';

(function(){
    
  $.fn.slideshow = function( options ) {
    
    if (this.length > 1){
      this.each(function() { $(this).slideshow(options) });
      return this;
    }

    var settings = {
      theme: false,
      swipe: false,
      autoplay: 0,
      random: false,
      initialSlide: undefined,
      controls: {
        enabled: true,
        prevLabel: "Prev",
        nextLabel: "Next"
      },
      autofit: false,
      forceWidth: 0
    };

    if ( options ) { 
      $.extend( settings, options );
    }
    
    // Setup elements
    var $this = $(this); // ul.atd-slideshow-slides
    var $slides = $this.children('li'); // li.atd-slideshow-slide
    var $toggles = $slides.find('[atd-slideshow-toggle]');
    var $slideshow = $('<div class="atd-slideshow" />'); // div.atd-slideshow
    var $arrowPrev = $('<button class="atd-slideshow-arrow prev">' + settings['controls']['prevLabel'] + '</button>');
    var $arrowNext = $('<button class="atd-slideshow-arrow next">' + settings['controls']['nextLabel'] + '</button>');
    var $pagination = false;
    var $full = false;
    var $autoplay = false;
    var $random = settings['random'];
    var $initialSlide = settings['initialSlide'];

    var elID = $(this).attr('id');
    
    if ($('[atd-slideshow-pagination="#' + elID + '"]').length) {
      $pagination = $('[atd-slideshow-pagination="#' + elID + '"]');
      $pagination.addClass($this.attr('id') + '-pagination');
    }
    
    if ($('[atd-slideshow-full="#' + elID + '"]').length) {
      $full = $('[atd-slideshow-full="#' + elID + '"]');
    }

    $slides.each(function() {
      $(this).attr('atd-slideshow-slide', $(this).index());
    });
    
    // Insert left/right controls into slideshow
    if (settings['controls']['enabled']) {
      $arrowPrev.appendTo($slideshow);
      $arrowNext.appendTo($slideshow);
    }
    
    // Insert ul -> li into slideshow
    $slides.addClass('atd-slideshow-slide');
    $this.replaceWith($slideshow).appendTo($slideshow).addClass('atd-slideshow-slides');
    
    // Slideshow positioning
    if (settings['autofit']) {
      $slides.width($slideshow.width());

      $(window).resize(function() {
        $slides.width($slideshow.width());
      });
    }

    var slideWidth = $slides.width();

    if (settings['forceWidth']) {
      slideWidth = settings['forceWidth'];
    }
    
    var current = $random ? Math.floor(Math.random() * $slides.length) : 0;
    var current = $initialSlide ? $initialSlide : 0;

    if($random && typeof $initialSlide === 'undefined') {
      current = $random ? Math.floor(Math.random() * $slides.length) : current;
      $random = false;
    }

    $this.css('margin-left', -(slideWidth * current) + 'px');
    window.setTimeout(
      function(){
          $this.addClass('animate');
      },
    5);

    if (settings['autoplay']) {
      $autoplay = setInterval(function() {
        switchSlide(current + 1);
      }, settings['autoplay']);
    }

    if (settings['swipe']) {
      $slideshow.swipe({
        allowPageScroll: "vertical",
        swipeLeft: function(event, direction, distance, duration, fingerCount) {
          switchSlide(current + 1);
          checkAutoplay();
        },
        swipeRight: function(event, direction, distance, duration, fingerCount) {
          switchSlide(current - 1);
          checkAutoplay();
        }
      });
    }
    
    $arrowPrev.click(function() {
      switchSlide(current - 1);
      checkAutoplay();
    });
    
    $arrowNext.click(function() {
      switchSlide(current + 1);
      checkAutoplay();
    });
    
    function switchSlide(next) {
      var old = current;
      current = next;

      if($random) {
        current = Math.floor(Math.random() * $slides.length);
        $random = false;
      }
      else {
        if (settings['autofit']) {
          if (current < 0) {
            current = $slides.length - 1;
          } else if (current >= $slides.length) {
            current = 0;
          }
        } else {
          if (current < 0) {
            current = 0;
          } else if (current >= $slides.length) {
            current = old;
          }
        }
      }
      

      $this.css('margin-left', -(slideWidth * current) + 'px');
      
      if ($pagination) {
        $pagination.children('[atd-slideshow-paginate]').removeClass('active');
        $pagination.children('[atd-slideshow-paginate="' + current + '"]').addClass('active');
        $pagination.attr('atd-slideshow-index', current);
      }

      if ($('[atd-slideshow-slide="' + current + '"]').attr('data-slide-title')) {
        var url = window.location.toString();
        var action = 'View Slide';
        var section = $('[atd-slideshow-slide="' + current + '"]').attr('data-slide-title');
        var track = ['_trackEvent', url, action, section];
        _gaq.push(track);
      }

      if ($toggles.length) {
        var toggle = $('[atd-slideshow-slide="' + current + '"]').find('[atd-slideshow-toggle]');
        var imgURL = toggle.attr('href');
        var img = $('<img src="' + imgURL + '" />');

        $toggles.attr('atd-slideshow-toggle', '');
        toggle.attr('atd-slideshow-toggle', 'active');

        if ($full) {
          $full.html(img);
        }
      }
    }

    function checkAutoplay() {
      if (settings['autoplay']) {
        clearInterval($autoplay);
      }
    }
      
    function slideResize() {
      if (slideWidth != $slides.width()) {
        slideWidth = $slides.width();
        $this.css('margin-left', -(slideWidth * current) + 'px');
        $this.addClass('resizing');
      } else {
        $this.removeClass('resizing');
      }
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(slideResize);
      }
    }
    
    if(window.requestAnimationFrame) {
      // Responsivized slideshow
      window.requestAnimationFrame(slideResize);
    }

    slideResize();

    // Setup pagination element if it's there
    
    if ($pagination) {
      for (i = 0; i < $slides.length; i++) {
        var $page;

        if ($slides.attr('data-pagination-label')) {
          $page = $('<button class="atd-slideshow-pagination-btn" atd-slideshow-paginate="' + i + '">' + $slides.eq(i).attr('data-pagination-label') + '</button>');
        } else {
          $page = $('<button class="atd-slideshow-pagination-btn" atd-slideshow-paginate="' + i + '">' + (i + 1) + '</button>');
        }

        $page.appendTo($pagination);
      }
      
      $pagination.children('[atd-slideshow-paginate="' + current + '"]').addClass('active');
      
      $pagination.children('[atd-slideshow-paginate]').click(function() {
        switchSlide(parseInt($(this).attr('atd-slideshow-paginate')));
        checkAutoplay();
      });
    }

    // IMG toggler

    if ($toggles) {
      $toggles.click(function(e) {
        e.preventDefault();
        switchSlide(parseInt($(this).parents('[atd-slideshow-slide]').attr('atd-slideshow-slide')));
      });
    }
    
    // Misc options
    
    if (settings['theme']) {
      $slideshow.addClass(settings['theme'] + ' ' + elID);
      
      if ($pagination) {
        $pagination.addClass(settings['theme'] + '-pagination');
      }
    }

    return this;
  };

})();
